<script type="ts">
  export let hideAuthor = false;
</script>

<div class="--updated-border rounded-xl overflow-hidden">
  {#if !hideAuthor}
    <div class="--skelet-child flex gap-x-2 px-3 items-center my-3">
      <div class="rounded-full w-8 aspect-square" />
      <div class="rounded-lg h-6 w-1/2" />
    </div>
  {/if}

  <div class="--skelet-bg aspect-square" />

  <div class="mt-4 flex --skelet-child pl-4">
    <div class="rounded-lg h-6 w-1/2" />
  </div>

  <div class="grid grid-cols-4 gap-x-2 --skelet-child h-6 px-4 mt-4 w-3/4 mb-8">
    <div class="rounded-lg" />
    <div class="rounded-lg" />
    <div class="rounded-lg" />
    <div class="rounded-lg" />
  </div>
</div>
